export const apiErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  if (Array.isArray(error)) {
    const message = error
      .map(item => apiErrorMessage(item, ''))
      .filter(Boolean)
      .join(', ');
    return message || fallback;
  }
  if (typeof error === 'object') {
    if (typeof error.detail === 'string') return error.detail;
    if (typeof error.message === 'string') return error.message;
    if (typeof error.error === 'string') return error.error;
    const nested = Object.values(error).find(value => typeof value === 'string' || Array.isArray(value));
    if (typeof nested === 'string') return nested;
    if (Array.isArray(nested)) return apiErrorMessage(nested, fallback);
  }
  return fallback;
};
